<!--
 * @description: 任务中心入口页面
 * @fileName: List.vue
 * @author: fugang
 * @date: 2019-04-26 21:35:03
 * @version: V1.0.0
!-->
<template>
  <div class="summary">
    <div class="block" @click="goToPage(1)">
      <div class="triangle-topleft">
        <span class="tr-txt">{{all}}</span>
      </div>
      <div class="mb20">
        <i class="iconfont icon-task-all f40"></i>
      </div>
      <div>{{$t('taskCenter.title.allTasks')}}</div>
      <div class="m20">{{$t('taskCenter.label.count')}}&nbsp;{{all}}</div>
    </div>
    <div class="block" @click="goToPage(2)">
      <div class="trrang-topleft">
        <span class="tr-txt">{{undo}}</span>
      </div>
      <div class="mb20">
        <i class="iconfont icon-weiwancheng f40"></i>
      </div>
      <div>{{$t('taskCenter.title.noFinishTask')}}</div>
      <div class="m20">{{$t('taskCenter.label.count')}}&nbsp;{{undo}}</div>
    </div>
    <div class="block" @click="goToPage(3)">
      <div class="triangle-topleft">
        <span class="tr-txt">{{finish}}</span>
      </div>
      <div class="mb20">
        <i class="iconfont icon-yiwancheng f40"></i>
      </div>
      <div>{{$t('taskCenter.title.finishTask')}}</div>
      <div class="m20">{{$t('taskCenter.label.count')}}&nbsp;{{finish}}</div>
    </div>
    <div class="block" @click="goToPage(4)">
      <div class="triangle-topleft">
        <span class="tr-txt">{{isMyCreate}}</span>
      </div>
      <div class="mb20">
        <i class="iconfont icon-zhipairenwu f40"></i>
      </div>
      <div>{{$t('taskCenter.title.assignTask')}}</div>
      <div class="m20">{{$t('taskCenter.label.count')}}&nbsp;{{isMyCreate}}</div>
    </div>
  </div>
</template>
<script>
import { API } from '../api'
export default {
  data() {
    return {
      all: '',
      undo: '',
      finish: '',
      isMyCreate: ''
    }
  },
  mounted() {
    let arr = [
      { flag: 'all' },
      { flag: 'undo' },
      { flag: 'finish' },
      { flag: 'isMyCreate' }
    ]
    arr.forEach(item => {
      this.getTotalData(item)
    })
  },
  methods: {
    goToPage(flag) {
      this.$router.push({
        path: './list',
        name: 'list',
        params: {
          mark: flag
        }
      })
    },
    getTotalData(data) {
      let params = {
        countType: data.flag
      }
      this.$fetch(API.bas.countTaskNum, params).then(res => {
        if (res.success) {
          if (data.flag == 'all') {
            this.all = res.returnObj
          } else if (data.flag == 'undo') {
            this.undo = res.returnObj
          } else if (data.flag == 'finish') {
            this.finish = res.returnObj
          } else if (data.flag == 'isMyCreate') {
            this.isMyCreate = res.returnObj
          }
        } else {
          this.$message({
            message: res.msgContent,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.summary {
  display: flex;
  justify-content: center;
  flex: 1;
  padding-top: 10%;
}
.triangle-topleft {
  width: 0;
  height: 0;
  border-top: 40px solid #0894ec;
  border-right: 40px solid transparent;
  position: relative;
  .tr-txt {
    position: absolute;
    top: -35px;
    left: 2px;
  }
}
.trrang-topleft {
  width: 0;
  height: 0;
  border-top: 40px solid #ff6600;
  border-right: 40px solid transparent;
  position: relative;
  .tr-txt {
    position: absolute;
    top: -35px;
    left: 2px;
  }
}
.block {
  cursor: pointer;
  width: 15%;
  height: 180px;
  border: solid 1px #39568c;
  margin-left: 30px;
  background-color: #39568c;
  display: flex;
  flex-direction: column;
}
.block div {
  text-align: center;
}

.f40 {
  font-size: 40px;
}
</style>
